import { antPrefixCls } from "utils/antPrefixclsConfig";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, List, Col } from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  UserOutlined,
  SkinOutlined,
} from "@ant-design/icons";
import { isEqual } from "lodash";
import { callApi } from "utils";
const Item = List.Item;
const Search = Input.Search;
import { SelectContext } from '../context';

class SelectBusiness extends Component {
  static contextType = SelectContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectObj: this.getDisabledObj(props.selects),
      disabledObj: this.getDisabledObj(props.disabledSelects),
    };
  }

  componentDidMount() {
    this.initList(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { organizations } = this.props;
    const { selects } = nextProps;

    if (
      !isEqual(organizations, nextProps.organizations) &&
      nextProps.organizations
    ) {
      this.initList(nextProps);
    }

    if (!isEqual(this.props.selects, selects)) {
      this.setState({
        selectObj: this.getSelectObj(selects),
      });
    }
  } //封装已选择列表

  getSelectObj = (selects = []) => {
    let obj = {};
    selects
      .filter(
        (val) =>
          val.sourceTypeB === "source_business_department" ||
          val.sourceTypeA === "source_business_department"
      )
      .forEach((val) => {
        obj[Number(val.sourceIdA)] ? "" : (obj[Number(val.sourceIdA)] = true);
      });
    return obj;
  }; //封装不可选择列表

  getDisabledObj = (disabledList = []) => {
    let obj = {};
    disabledList
      .filter(
        (val) =>
          val.sourceTypeB === "bussource_business_departmentiness" ||
          val.sourceTypeA === "source_business_department"
      )
      .forEach((val) => {
        obj[Number(val.sourceIdA)] ? "" : (obj[Number(val.sourceIdA)] = true);
      });
    return obj;
  };
  /**
   * 获取岗位
   */

  initList = (props) => {
    this.setState({
      loading: true,
    });
    const { organizations } = props;
    const { manageSceneFlag } = this.context;
    let api = "/newOrg/listOrganizationJobPosition";
    let data = {
      pageSize: 10000,
      ownerType: "EhOrganizations",
      ownerId: organizations.id,
      appId: window.$$context.appId,
      manageSceneFlag
    };
    callApi({
      api,
      data,
      success: ({ organizationJobPositionDTOS = [] }) => {
        let list = [];
        list.push(
          {
            id: organizations.managerDetailId || -1,
            name: "负责人",
            type: "manager",
          },
          {
            id: organizations.superiorDetailId || -2,
            name: "分管领导",
            type: "superior",
          }
        );
        list = list.concat(organizationJobPositionDTOS);
        this.setState({
          loading: false,
          dataSource: list,
          organizationJobPositionDTOS: list,
        });
      },
    });
  };
  /**
   * 根据关键字搜索
   */

  searchByKeywords = (keywords = "") => {
    keywords = keywords.trim();
    let { dataSource = [], organizationJobPositionDTOS = [] } = this.state;

    if (!keywords) {
      return this.setState({
        dataSource: organizationJobPositionDTOS,
      });
    }

    this.setState({
      dataSource: dataSource.filter((obj) => obj.name.indexOf(keywords) > -1),
    });
  }; // 点击列表数据 添加一条数据

  onitemClick = (item) => {
    let { selectObj } = this.state;

    if (selectObj[item.id]) {
      if (item.type) {
        this.props.removeItems([
          {
            selectionName: "业务责任部门" + item.name,
            sourceIdA: item.id,
            flowUserSelectionType: item.type,
            sourceTypeA: "source_business_department",
          },
        ]);
      } else {
        this.props.removeItems([
          {
            selectionName: "业务责任部门-" + item.name,
            flowUserSelectionType: "position",
            sourceIdA: item.id,
            sourceTypeA: "source_position",
            sourceTypeB: "source_business_department",
          },
        ]);
      }
    } else {
      if (item.type) {
        this.props.addItems([
          {
            selectionName: "业务责任部门" + item.name,
            sourceIdA: item.id,
            flowUserSelectionType: item.type,
            sourceTypeA: "source_business_department",
          },
        ]);
      } else {
        this.props.addItems([
          {
            selectionName: "业务责任部门-" + item.name,
            flowUserSelectionType: "position",
            sourceIdA: item.id,
            sourceTypeA: "source_position",
            sourceTypeB: "source_business_department",
          },
        ]);
      }
    }
  };

  render() {
    const { loading, searchText, dataSource, disabledObj, selectObj } =
      this.state;
    return (
      <Col className="tree-box">
        <div className="select-box-search">
          <Search
            placeholder="请输入岗位"
            value={searchText}
            onChange={(e) => {
              this.setState({
                searchText: e.target.value,
              });
              if (!e.target.value) this.searchByKeywords();
            }}
            onSearch={this.searchByKeywords}
          />
          <CloseCircleOutlined
            className={searchText ? "search-close-circle" : "display-none"}
            type="close-circle"
            onClick={() =>
              this.setState(
                {
                  searchText: "",
                },
                this.searchByKeywords()
              )
            }
          />
        </div>
        <div className={"select-scroll-view"}>
          <List
            dataSource={dataSource}
            size={"small"}
            split={false}
            loading={loading}
            locale={{
              emptyText: "未找到相关结果",
            }}
            renderItem={(item) => {
              let className = "tree-list-item";

              if (disabledObj[item.id] && selectObj[item.id]) {
                className += ` ${antPrefixCls.get()}-tree-node-selected disabled-click`;
              } else if (disabledObj[item.id]) {
                className += " disabled-click";
              } else if (selectObj[item.id]) {
                className += ` ${antPrefixCls.get()}-tree-node-selected`;
              }

              return (
                <Item
                  className={className}
                  onClick={() => {
                    !disabledObj[item.id] && this.onitemClick(item);
                  }}
                >
                  {item.type ? (
                    <UserOutlined className="list-type-icon" />
                  ) : (
                    <SkinOutlined className="list-type-icon" />
                  )}
                  {item.name}
                  <CheckOutlined className={"select-modal-checked-icon"} />
                </Item>
              );
            }}
          />
        </div>
      </Col>
    );
  }
}

SelectBusiness.propTypes = {
  // 组织架构数据
  organizations: PropTypes.object.isRequired,
  organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /* 以下是configs额外传进来的参数 */
  // 扩展的树节点，格式为 [{id: -1, name: '不限部门', type: 'source_unlimited_department', childrens: [...]}]
  extendTree: PropTypes.array,
  disabledSelects: PropTypes.array,
  selects: PropTypes.array,
  addItems: PropTypes.func.isRequired,
  removeItems: PropTypes.func.isRequired,
};
export default SelectBusiness;
